import type { FaireProductEntity } from "../../entity_types/product";

export const p_xr7z8zbmb5: FaireProductEntity = {
  token: "p_xr7z8zbmb5",
  type: "product",
  name: "Relaxing Squeeze Stress Toy Colorful TPR Fidget Cube",
  brandToken: "b_7my2jr2fhg",
  brandName: "Miami Sample Apparel",
  imageUrl:
    "https://cdn.faire.com/fastly/e1ffb84540761940d08624a9e7401aeaa767488fbeffbc9d87889b32437ac5a5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/efa1d4863b4d8ae34060633c2d75568e73e963f2898a2c382e46e3269a50396e.jpeg",
    "https://cdn.faire.com/fastly/bba1d88d7751b4b1a0a18102f66e89daa2448773aa331fba8ff33f029e9652af.jpeg",
    "https://cdn.faire.com/fastly/efd225d9d7dc1b574f8519c4cae71625e69b7da6a24c482a76397ca8e27c9270.jpeg",
    "https://cdn.faire.com/fastly/5a7d201b06b0f85d5d4d81658f990ae17f8c8efc9e0dd38487157f0034ec6842.jpeg",
  ],
  priceDollars: 7.49,
  description:
    "Experience the ultimate stress relief with our Colorful TPR Fidget Cube designed for users aged 15-35. This soft and squishy toy promotes sensory exploration and fine motor skills while offering a satisfying slow rebound. Perfect for reducing anxiety and enhancing focus, it's a must-have for both adults and kids!\nFeatures: \n * Material: TPR (Thermoplastic Rubber) \n * Size Options: Available in formats such as 3cm and 5.5cm \n * Color Variations: Includes rainbow colors, smiley faces, and themed designs \n * Portable: Ideal for use at home, work, or on the go \n * Unique Textures: Various surfaces to keep hands engaged \n * Fun and Engaging: Perfect for everyone, regardless of age \nOur Colorful TPR Fidget Cube is not just a toy, but also an effective stress-relief tool that enhances cognitive engagement. With its variety of colors and textures, it's perfect for anyone looking to fidget while working, studying, or relaxing.\n",
  tags: [],
  msrpDollars: 14.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:30.954Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
